import { render, staticRenderFns } from "./EmulatorStyles.vue?vue&type=template&id=dec2e0d4&scoped=true"
import script from "./EmulatorStyles.vue?vue&type=script&lang=js"
export * from "./EmulatorStyles.vue?vue&type=script&lang=js"
import style0 from "./EmulatorStyles.vue?vue&type=style&index=0&id=dec2e0d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec2e0d4",
  null
  
)

export default component.exports